export const supportClass = 'button_tawk_support';
